/** Page de contact WOSH, ouverte depuis le profil et les commandes. */
export const SUPPORT_URL = "https://www.wosh.be/contact";

/**
 * Site du pressing (champ `website` du laundry place), en lien absolu :
 * le back-office l'enregistre parfois sans protocole (« prisma.be »).
 * Tout ce qui n'est pas http(s) est ignoré.
 */
export const websiteUrl = (raw) => {
  const value = String(raw || "").trim();
  if (!value || /^(null|undefined)$/i.test(value)) return null;
  const url = /^https?:\/\//i.test(value) ? value : `https://${value}`;
  try {
    const parsed = new URL(url);
    return /^https?:$/.test(parsed.protocol) && parsed.hostname.includes(".") ? parsed.href : null;
  } catch (error) {
    return null;
  }
};
